(function () {

  'use strict';

  angular
    .module('app')
    .directive('loading', ['LoadService', loading]);

  function loading(LoadService) {

    return {
        restrict: 'E',
        // template: '<div id="loader" class="loading-backdrop"> ' +
        //             '<div class="loader"> ' +
        //               '<div class="wrapper"> ' +
        //                 '<div class="cssload-loader">' +
        //                 '</div>' +
        //               '</div ' +
        //             '</div ' +
        //           '</div>'
        template: '<div id="loader" class="loader-wrapper">' +
                    '<div class="loader">' +
                      '<div class="roller"></div>' +
                      '<div class="roller"></div>' +
                    '</div>' +

                    '<div id="loader2" class="loader">' +
                      '<div class="roller"></div>' +
                      '<div class="roller"></div>' +
                    '</div>' +

                    '<div id="loader3" class="loader">' +
                      '<div class="roller"></div>' +
                      '<div class="roller"></div>' +
                    '</div>' +
                  '</div>'
    };
  }

}());